import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { LoaderService } from '../services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: false,
  template: `
    @if (loading$ | async) {
      <div class="global-loader">
        <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
      </div>
    }
    `,
  styleUrls: ['loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  loading$: typeof this.loaderService.loading;
  constructor(public loaderService: LoaderService,  private cdr: ChangeDetectorRef) {
    this.loading$ = this.loaderService.loading;
  }

  ngAfterViewInit() {
    setTimeout(() => this.cdr.detectChanges());
  }
}
